import { render, staticRenderFns } from "./FormBuildersList.vue?vue&type=template&id=6b9f8f85&scoped=true"
import script from "./FormBuildersList.vue?vue&type=script&lang=js"
export * from "./FormBuildersList.vue?vue&type=script&lang=js"
import style0 from "./FormBuildersList.vue?vue&type=style&index=0&id=6b9f8f85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9f8f85",
  null
  
)

export default component.exports